"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var InfoIcon_1 = require("../Icons/InfoIcon");
var AlertIcon_1 = require("../Icons/AlertIcon");
var CheckIcon_1 = require("../Icons/CheckIcon");
var Provider_1 = require("../Provider");
var messageBoxTypes = [
    'default',
    'info',
    'error',
    'success'
];
var propTypes = {
    type: PropTypes.oneOf(messageBoxTypes),
    children: PropTypes.node.isRequired
};
/**
 * The `MessageBox` can be used to highlight messages of special importance.
 * The content of the component can be freely defined.
 *
 * <div>
 *   <p class="box box--ux">
 *     The content should not exceed 350 characters of text.
 *   </p>
 * </div>
 */
var MessageBox = /** @class */ (function (_super) {
    __extends(MessageBox, _super);
    function MessageBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageBox.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, type = _a.type, other = __rest(_a, ["children", "className", "type"]);
        var componentClassName = classNames(className, 'ee_message-box', "ee_message-box--type-" + type);
        return (React.createElement("div", __assign({}, other, { className: componentClassName }),
            type === 'info' && (React.createElement("span", { className: "ee_message-box__icon-wrapper" },
                React.createElement(InfoIcon_1.InfoIcon, { className: "ee_message-box__icon" }))),
            type === 'success' && (React.createElement("span", { className: classNames('ee_message-box__icon-wrapper', 'ee_message-box__icon-wrapper--success') },
                React.createElement(CheckIcon_1.CheckIcon, { width: "2.3em", height: "2.3em", className: classNames('ee_message-box__icon', 'ee_message-box__icon--success') }))),
            type === 'error' && (React.createElement(Provider_1.ErgoElementsContext.Consumer, null, function (context) {
                return context.theme === 'ergo' && (React.createElement("span", { className: "ee_message-box__icon-wrapper" },
                    React.createElement(AlertIcon_1.AlertIcon, { className: classNames('ee_message-box__icon', 'ee_message-box__icon--error') })));
            })),
            children));
    };
    MessageBox.propTypes = propTypes;
    MessageBox.defaultProps = {
        type: 'default'
    };
    return MessageBox;
}(react_1.Component));
exports.MessageBox = MessageBox;
exports.default = MessageBox;
//# sourceMappingURL=MessageBox.js.map
